(function (app, ng) {
    app.controller("approveDeclineTransactionController", approveDeclineTransactionController);

    approveDeclineTransactionController.$inject = ["$mdDialog", "figEmailer", "queueEntryApi"];

    function approveDeclineTransactionController($mdDialog, figEmailer, queueEntryApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isClosing: false
                },
                close: close,
                performAction: performAction
            });

        function close() {
            $ctrl.UI.isClosing = true;

            return $mdDialog.hide();
        }

        function performAction(transaction, email) {
            $ctrl.updating = true;

            function afterEmail() {
                if ($ctrl.action === "Decline")
                    transaction.State = "Rejected";
                else
                    transaction.State = "Approved";

                transaction.Transaction.LastUpdatedOn = new Date();
                transaction.StateUpdatedOn = new Date();
                transaction.StateUpdatedBy = $ctrl.user;

                return queueEntryApi.updateQueueEntryStatus(transaction);
            }

            return $mdDialog.hide().then(function () {
                if (email)
                    figEmailer.open({
                        title: $ctrl.transactionGroup.Name + ($ctrl.action === "Decline" ? " Decline" : " Approval"),
                        secondaryTitle: $ctrl.agent.Person.FirstName +
                            " " +
                            $ctrl.agent.Person.LastName +
                            ": " +
                            $ctrl.transaction.Transaction.Client.Person.FirstName +
                            " " +
                            $ctrl.transaction.Transaction.Client.Person.LastName +
                            " - " +
                            $ctrl.transaction.Transaction.Name,
                        subject: $ctrl.transactionGroup.Name +
                            ($ctrl.action === "Decline" ? " - Decline" : " - Approval") +
                            " - " +
                            $ctrl.agent.Person.FirstName +
                            " " +
                            $ctrl.agent.Person.LastName +
                            ": " +
                            $ctrl.transaction.Transaction.Client.Person.FirstName +
                            " " +
                            $ctrl.transaction.Transaction.Client.Person.LastName,
                        to: $ctrl.agent.Email ? [$ctrl.agent.Email] : null,
                        body: generateTemplate()
                    }).then(function() {
                        afterEmail();
                    });
                else {
                    afterEmail();
                }
            });
        }

        function generateTemplate() {
            var template = "Hello " +
                $ctrl.agent.Person.FirstName +
                ",\n\n";

            if ($ctrl.action === "Decline") {
                template +=
                    "This email is to inform you your transaction for " + $ctrl.transaction.Transaction.Client.Person.FirstName +
                    " " + $ctrl.transaction.Transaction.Client.Person.LastName
                    + " has been declined by " + $ctrl.transactionGroup.Name + " due to the following reasons:";

                $ctrl.notes.forEach(function (n) {
                    template += "\n\n- " + n.Text;
                });

                template += "\n\nThank you,\n" + $ctrl.user.FirstName + " " + $ctrl.user.LastName;

                return template;
            } else {
                template += "This email is to inform you your transaction for " +
                    $ctrl.transaction.Transaction.Client.Person.FirstName +
                    " " + $ctrl.transaction.Transaction.Client.Person.LastName +
                    " has been approved by " + $ctrl.transactionGroup.Name + ".";

                template += "\n\nThank you,\n" + $ctrl.user.FirstName + " " + $ctrl.user.LastName;

                return template;
            }
        }
    }
})(window.app, window.angular); // jshint ignore:line